<template>
    <div class="modal fade" id="modal-payform" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header h5 mb-0">
                    <div>Formas de pago</div><button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span> </button>
                </div>
                <div class="modal-body p-0">
                    <div>
                        <strong>
                            Tarjeta de crédito en hasta 18 meses sin intereses*
                        </strong>
                    </div>
                </div>
                <div class="modal-footer"><button type="button" class="btnPrimary btnPrimary--xs" data-dismiss="modal">
                        Cerrar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        msg: String,
    },
    data() {
        return {
            name: "Nombre"

        };
    },
};
</script>
    